import { motion } from "framer-motion";
import { WaitlistForm } from "./WaitlistForm";
import { HeroDemo } from "./HeroDemo";

const fade = (d) => ({ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { delay: d, duration: 0.6 } });

export const Hero = () => (
  <section data-testid="hero-section" className="relative overflow-hidden pb-24 pt-36 lg:pb-32 lg:pt-44">
    <div className="pointer-events-none absolute -left-40 top-20 h-96 w-96 rounded-full bg-cyan/10 blur-3xl" />
    <div className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 rounded-full bg-pink/10 blur-3xl" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-7">
        <motion.p {...fade(0)} className="eyebrow mb-6">Early access · Launching soon</motion.p>
        <motion.h1 {...fade(0.1)} className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          Just hit record.<br />
          Your <span className="text-cyan">tasks</span> and <span className="text-pink">reminders</span> write themselves.
        </motion.h1>
        <motion.p {...fade(0.2)} className="mt-6 max-w-xl text-base text-muted-foreground md:text-lg">
          Tilla' is your personal AI secretary. It listens to your lectures, study groups and conversations, then turns them into organized, searchable notes, summaries — and creates your tasks and reminders on its own.
        </motion.p>
        <motion.div {...fade(0.3)} className="mt-10">
          <WaitlistForm source="hero" id="hero" />
          <p className="mt-4 font-mono text-xs text-muted-foreground">5 recordings free · then €4.99/month · no note-taking, ever</p>
        </motion.div>
      </div>
      <div className="lg:col-span-5">
        <HeroDemo />
      </div>
    </div>
  </section>
);
